import SubscriptionDetailMain from "./SubscriptionDetailMain";
import SubscriptionGrid from "./SubscriptionGrid";
import React from "react";
import { NavigateFunction, Params, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import { Loader, UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import {
  ItemsStore,
  RolesAndPermissionStore,
  SubscriptionStore,
} from "../../../shared/store";
import { DashboardGrid } from "../../../shared/styles";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  subscriptionStore: SubscriptionStore;
  params: Readonly<Params<string>>;
  navigate: NavigateFunction;
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
};

const SubscriptionRoutes: React.FC<IProps> = ({
  params,
  itemStore,
  navigate,
  subscriptionStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  function subscriptionId() {
    const split = ((params && params["*"]) || "").split("/");
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return null;
  }
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  return (
    <DashboardGrid>
      <Routes>
        <Route
          path={`/`}
          element={
            <SubscriptionGrid
              itemStore={itemStore}
              subscriptionStore={subscriptionStore}
              navigate={navigate}
              merchantAccountStore={merchantAccountStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
            />
          }
        />
        <Route
          path={`/detail/:id`}
          element={
            <SubscriptionDetailMain
              subscriptionId={subscriptionId() || ""}
              itemStore={itemStore}
              subscriptionStore={subscriptionStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
              merchantAccountStore={merchantAccountStore}
            />
          }
        />
      </Routes>
    </DashboardGrid>
  );
};

export default withRouter(observer(SubscriptionRoutes));
